import OverviewCards from './components/OverviewCards';
import VisitTrendChart from './components/VisitTrendChart';
import ArticleRanking from './components/ArticleRanking';
import TrafficAnalysis from './components/TrafficAnalysis';
import PageRanking from './components/PageRanking';

export default function AdminDashboard() {
  const now = new Date();
  const dateStr = `${now.getFullYear()}年${now.getMonth() + 1}月${now.getDate()}日`;

  return (
    <div className="space-y-5">
      {/* 页面标题 */}
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-lg font-bold text-gray-800">网站访问态势感知</h2>
          <p className="text-sm text-gray-400 mt-0.5">数据统计截至 {dateStr}，近30天累计数据</p>
        </div>
        <div className="flex items-center gap-2 text-xs text-gray-400">
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-refresh-line"></i>
          </div>
          <span>数据每小时更新</span>
        </div>
      </div>

      {/* 总览卡片 */}
      <OverviewCards />

      {/* 访问趋势图 */}
      <VisitTrendChart />

      {/* 页面排行 + 文章排行 */}
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
        <PageRanking />
        <ArticleRanking />
      </div>

      {/* 流量分析（设备/来源/地区） */}
      <TrafficAnalysis />
    </div>
  );
}
